import { render, staticRenderFns } from "./ChoiceStepDocument.vue?vue&type=template&id=434b42ca&"
import script from "./ChoiceStepDocument.vue?vue&type=script&lang=js&"
export * from "./ChoiceStepDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports